import React from 'react'

const Pagination = ({ currentPage, totalPages, onPageChange, itemsPerPage, totalItems }) => {
  const startItem = itemsPerPage * (currentPage - 1) + 1
  const endItem = Math.min(itemsPerPage * currentPage, totalItems)

  return (
    <nav
      className='flex flex-col w-fit ml-auto items-center space-y-2 mr-0 mt-4'
      aria-label='Pagination'
    >
      <div className='flex items-center w-fit justify-center space-x-2'>
        <button
          className='bg-gray-200 disabled:bg-gray-100 disabled:text-gray-300 text-gray-700 px-4 py-2 rounded flex items-center justify-center'
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          aria-label='Go to previous page'
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            className='inline w-4 h-4'
            fill='none'
            viewBox='0 0 24 24'
            stroke='currentColor'
          >
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth={2}
              d='M15 19l-7-7 7-7'
            />
          </svg>
        </button>

        <PaginationItems
          totalPages={totalPages}
          currentPage={currentPage}
          onPageChange={onPageChange}
        />

        <button
          className='bg-gray-200 disabled:bg-gray-100 disabled:text-gray-300 text-gray-700 px-4 py-2 rounded flex items-center justify-center'
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          aria-label='Go to next page'
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            className='inline w-4 h-4'
            fill='none'
            viewBox='0 0 24 24'
            stroke='currentColor'
          >
            <path strokeLinecap='round' strokeLinejoin='round' strokeWidth={2} d='M9 5l7 7-7 7' />
          </svg>
        </button>
      </div>
      <p>
        {startItem} - {endItem} de {totalItems} ítems
      </p>
    </nav>
  )
}

const PaginationItems = ({ totalPages, currentPage, onPageChange }) => {
  const pageWindow = 5
  let start = 1
  let end = pageWindow

  // Ajusta la ventana de páginas
  if (currentPage > Math.floor(pageWindow / 2)) {
    start = currentPage - Math.floor(pageWindow / 2)
    end = start + pageWindow - 1
  }
  if (end > totalPages) {
    end = totalPages
    start = Math.max(1, end - pageWindow + 1)
  }

  const pages = []
  for (let i = start; i <= end; i++) {
    pages.push(i)
  }

  return (
    <ul className='flex space-x-1' role='list'>
      {start > 1 && (
        <>
          <li>
            <button
              className={`px-3 py-1 rounded bg-gray-200 text-gray-700`}
              onClick={() => onPageChange(1)}
              aria-label='Go to page 1'
            >
              1
            </button>
          </li>
          <li>
            <span className='px-2'>...</span>
          </li>
        </>
      )}
      {pages.map((page) => (
        <li key={page}>
          <button
            className={`px-3 py-1 rounded ${
              page === currentPage ? 'bg-blue-500 text-white' : 'bg-gray-200 text-gray-700'
            }`}
            onClick={() => onPageChange(page)}
            aria-current={page === currentPage ? 'page' : undefined}
            aria-label={`Go to page ${page}`}
          >
            {page}
          </button>
        </li>
      ))}
      {end < totalPages && (
        <>
          <li>
            <span className='px-2'>...</span>
          </li>
          <li>
            <button
              className={`px-3 py-1 rounded bg-gray-200 text-gray-700`}
              onClick={() => onPageChange(totalPages)}
              aria-label={`Go to page ${totalPages}`}
            >
              {totalPages}
            </button>
          </li>
        </>
      )}
    </ul>
  )
}

export default Pagination
